import {
    TWICL_END_DETAILS,
    TWICL_INITIAL_DETAILS,
    TWICL_QUALIFICATION_DETAILS
} from 'common/application.const/Licence/MyApplication/TWICLApplication';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatTWICLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);


    licence = {
        id: 'telecommunication-wiring-installer-class-licence',
        formID: 'telecommunication-wiring-installer-class-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
        values: {
            [`${TWICL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-institution`]: licenceDetails?.QualificationDetails?.InstitutionDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-certificate-number`]: licenceDetails?.QualificationDetails?.CertificateNo ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-course-name`]: licenceDetails?.QualificationDetails?.CourseNameDesc ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-completion-date`]: licenceDetails?.QualificationDetails?.CompletionDate ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-other-institution-name`]: licenceDetails?.QualificationDetails?.OtherInstitution ?? '-',
            [`${TWICL_QUALIFICATION_DETAILS}-other-course-name`]: licenceDetails?.QualificationDetails?.OtherCourseName ?? '-',
            [`${TWICL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfCertificate ?? '-',
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
            values: {
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.cancellationInformation?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: 'Application Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-telecommunication-wiring-installer-class-licence',
            formID: 'amend-telecommunication-wiring-installer-class-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication-TELE' ? 'Application Details' : 'Licence Details',
            values: {
                [`${TWICL_INITIAL_DETAILS}-service-provided`]: licenceDetails?.ServiceDetails?.ServicesProvidedDesc ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-institution`]: licenceDetails?.QualificationDetails?.InstitutionDesc ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-certificate-number`]: licenceDetails?.QualificationDetails?.CertificateNo ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-course-name`]: licenceDetails?.QualificationDetails?.CourseNameDesc ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-completion-date`]: licenceDetails?.QualificationDetails?.CompletionDate ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-other-institution-name`]: licenceDetails?.QualificationDetails?.OtherInstitution ?? '-',
                [`${TWICL_QUALIFICATION_DETAILS}-other-course-name`]: licenceDetails?.QualificationDetails?.OtherCourseName ?? '-',
                [`${TWICL_END_DETAILS}-proof-of-certificate`]: licenceDetails?.SupportingDocumentsAPImport?.ProofOfCertificate ?? '-',
            }
        };
    }

    return licence;
};

const twiclPayloadApplication = {
    formatTWICLApplication
};

export default twiclPayloadApplication;
